import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "./AppConfig";
export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() => import("../screens/login/Login")),
  },
  {
    key: "policy",
    path: `${AUTH_PREFIX_PATH}/policy`,
    component: React.lazy(() => import("../screens/login/Consent")),
  },
  {
    key: "opt-verify",
    path: `${AUTH_PREFIX_PATH}/otp-verify`,
    component: React.lazy(() => import("../screens/login/LoginOtp")),
  },
];

export const protectedRoutes = [
  {
    key: "landingPage",
    path: `${APP_PREFIX_PATH}/home`,
    component: React.lazy(() => import("../components/landingPage")),
  },
  {
    key: "portfolioDirectory",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioDirectory`,
    component: React.lazy(() =>
      import("../screens/portfolioApp/portfolio/PortfolioDirectory")
    ),
  },
  {
    key: "portfolioBuilder",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioBuilder`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioBuilder")),
  },
  {
    key: "portfolioSearch",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioBuilder/Search`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioSearch")),
  },
  {
    key: "portfolioList",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioBuilder/PortfolioList`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioList")),
  },
  {
    key: "portfolioList",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioBuilder/PortfolioList/debug=true`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioList")),
  },
  {
    key: "portfolioSaved",
    path: `${APP_PREFIX_PATH}/Portfolio/Portfoliosaved/:portfolioId`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioList/portfolioThankyou")),
  },
  {
    key: "portfolioEdit",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioEdit/:portfolioId`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioEdit")),
  },
  {
    key: "portfolioEdit",
    path: `${APP_PREFIX_PATH}/Portfolio/PortfolioEdit/debug=true/:portfolioId`,
    component: React.lazy(() => import("../screens/portfolioApp/portfolioEdit")),
  },
  {
    key: "ValuationEdit",
    path: `${APP_PREFIX_PATH}/Valuations/ValuationEdit/:ValuationId`,
    component: React.lazy(() => import("../screens/valuation/valuations")),
  },
  {
    key: "ValuationEdit",
    path: `${APP_PREFIX_PATH}/Valuations/ValuationEdit/debug=true/:ValuationId`,
    component: React.lazy(() => import("../screens/valuation/valuations")),
  },
  {
    key: "valuation",
    path: `${APP_PREFIX_PATH}/Valuations`,
    component: React.lazy(() => import("../screens/valuation/homescreen")),
  },
  {
    key: "adminFactor",
    path: `${APP_PREFIX_PATH}/adminPanel/factors`,
    component: React.lazy(() => import("../screens/adminstration/factors")),
  },
  {
    key: "adminDealerships",
    path: `${APP_PREFIX_PATH}/adminPanel/dealerships`,
    component: React.lazy(() => import("../screens/adminstration/dealerships")),
  },
  {
    key: "kpiadmin",
    path: `${APP_PREFIX_PATH}/adminPanel/kpiadmin`,
    component: React.lazy(() => import("../screens/adminstration/kpiadmin")),
  },
  {
    key: "basemultiple",
    path: `${APP_PREFIX_PATH}/adminPanel/basemultiple`,
    component: React.lazy(() => import("../screens/adminstration/basemultiple")),
  },
  {
    key: "factorpage",
    path: `${APP_PREFIX_PATH}/adminPanel/factorpage/:id`,
    component: React.lazy(() => import(`../screens/adminstration/factorpage`)),
  },
  {
    key: "statebrandmultiple",
    path: `${APP_PREFIX_PATH}/adminPanel/state-brand-multiple`,
    component: React.lazy(() => import(`../screens/adminstration/stateBrandMultiple`)),
  },
  {
    key: "tunings",
    path: `${APP_PREFIX_PATH}/adminPanel/tunings`,
    component: React.lazy(() => import(`../screens/adminstration/tunings`)),
  },
  {
    key: "dealershipSales",
    path: `${APP_PREFIX_PATH}/adminPanel/dealershipSales`,
    component: React.lazy(() => import(`../screens/adminstration/dealershipSales`)),
  },
  {
    key: "assignDealers",
    path: `${APP_PREFIX_PATH}/adminPanel/assignDealers`,
    component: React.lazy(() => import(`../screens/adminstration/assignDealers`)),
  },
  {
    key: "lastLogins",
    path: `${APP_PREFIX_PATH}/adminPanel/lastLogins`,
    component: React.lazy(() => import(`../screens/adminstration/lastLogins`)),
  },
  {
    key: "feedbacks",
    path: `${APP_PREFIX_PATH}/adminPanel/feedbacks`,
    component: React.lazy(() => import(`../screens/adminstration/feedbacks`)),
  },

  {
    key: "impactAnalysis",
    path: `${APP_PREFIX_PATH}/analytics/impact`,
    component: React.lazy(() => import(`../components/analytics/ImpactAnalysisPage`)),
  },
  {
    key: "aiAnalytics",
    path: `${APP_PREFIX_PATH}/ai-analytics`,
    component: React.lazy(() => import(`../components/aiAnalytics/AIAnalytics`)),
  },
  {
    key: "reportResults",
    path: `${APP_PREFIX_PATH}/ai-analytics/report-results`,
    component: React.lazy(() => import(`../components/aiAnalytics/ReportResultsPage`)),
  },
  {
    key: "marketShare",
    path: `${APP_PREFIX_PATH}/ai-analytics/market-share`,
    component: React.lazy(() => import(`../components/aiAnalytics/MarketSharePage`)),
  },
  {
    key: "whatDollarBuy",
    path: `${APP_PREFIX_PATH}/ai-analytics/what-dollar-buy`,
    component: React.lazy(() => import(`../components/aiAnalytics/WhatDollarBuyModal`)),
  },
];
